$(document).ready(function(){
    $('.featured-collections .grid.product-grid').slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 400,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
              arrows: true,
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
              arrows: true,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: true,
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
    });
    $('.featured-collections .slick-dots').wrapAll('<div class="slider-controls"></div>');
    $('.featured-collections .slick-prev').prependTo('.featured-collections .slider-controls');
    $('.featured-collections .slick-next').appendTo('.featured-collections .slider-controls');

    // Function to center the active dot
    $('.featured-collections').on('afterChange', function(event, slick, currentSlide){
        var $dots = $('.featured-collections .slick-dots li');
        var totalDots = $dots.length;
        var visibleDots = 5; // Change this number to adjust visible dots
    
        $dots.hide();
        
        // Calculate range to display
        var start = Math.max(0, currentSlide - Math.floor(visibleDots / 2));
        var end = Math.min(totalDots - 1, start + visibleDots - 1);
    
        // Adjust if at the start or end of the dot list
        if (end - start < visibleDots - 1) {
            start = Math.max(0, end - visibleDots + 1);
        }
    
        // Show the calculated range of dots
        $dots.slice(start, end + 1).show();
    });
    
    // Trigger the function initially to set up the dots
    $('.featured-collections').slick('slickGoTo', 0);

  
    $('.commitment-section .multicolumn-list').slick({
        infinite: false,
        speed: 400,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
              arrows: true,
              infinite: false
            }
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: true,
              infinite: false
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
    });
    $('.commitment-section .slick-dots').wrapAll('<div class="slider-controls"></div>');
    $('.commitment-section .slick-prev').prependTo('.commitment-section .slider-controls');
    $('.commitment-section .slick-next').appendTo('.commitment-section .slider-controls');
    
  
});


    $(document).ready(function(){
        // $(document).on('click', '.casetype', (e)=>{
        //    $('.casetype-model-box-main').show();
        // })
         $('.case-type-selection').on('change', 'input', function() {
            //var selectedValue = $('input[name="Case type"]:checked').val();
            var selectedValue = $('input[name]').filter(function() {
              return this.name.toLowerCase() === "case type";
            }).filter(':checked').val();
            console.log(selectedValue);
            $('.select.case-type-select select').val(selectedValue);
        });
        setTimeout(function(){
            $('.single-product .jdgm-rev-widg__reviews .jdgm-rev').each(function(){
                $(this).find('.jdgm-row-profile').appendTo(this).find('.jdgm-rev__content');
            });
        }, 1000);

        $('.single-product .image-with-text-diff-layout .button').click(function(event){
            event.preventDefault();
             $('html, body').animate({
                  scrollTop: $("#MainContent").offset().top - 200
              }, 2000);
        });

         $('.tool-tip.size-guide').click(function(){
              $('.size-guide-model-box-main').show();
         });
      
         $('.clode-model').click(function(){
              $(this).parents('.size-guide-model-box-main').hide();
         });
        
         $('.tool-tip.casetype').click(function(){
              $('.casetype-model-box-main').show();
         });
         $('.clode-model').click(function(){
              $(this).parents('.casetype-model-box-main').hide();
         });

        $('ul.slick-dots').each(function() {
            if ($(this).children('li').length === 1) {
                $(this).hide();
            }
        });
    });

function showSizeGuide() {
  document.querySelector('.size-guide-model-box-main').style.display = 'block';
}

function showCaseType() {
  document.querySelector('.casetype-model-box-main').style.display = 'block';
}
(function () {
  function refreshUpcart() {
    function runRefresh() {
      if (typeof window.upcartRefreshCart === 'function') {
        window.upcartRefreshCart();
        return true;
      }

      return false;
    }

    if (!runRefresh()) {
      setTimeout(runRefresh, 500);
    }
  }

  function refreshHeaderCart() {
    var cartUrl =
      window.routes && window.routes.cart_url
        ? window.routes.cart_url
        : '/cart';

    fetch(cartUrl + '?section_id=cart-icon-bubble', {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to refresh cart badge');
        }

        return response.text();
      })
      .then(function (html) {
        var currentCartLink =
          document.querySelector('#cart-icon-bubble');

        var parser = new DOMParser();
        var newDocument =
          parser.parseFromString(html, 'text/html');

        var updatedCartLink =
          newDocument.querySelector('#cart-icon-bubble');

        if (currentCartLink && updatedCartLink) {
          currentCartLink.innerHTML =
            updatedCartLink.innerHTML;

          var updatedLabel =
            updatedCartLink.getAttribute('aria-label');

          if (updatedLabel) {
            currentCartLink.setAttribute(
              'aria-label',
              updatedLabel
            );
          }
        }
      })
      .catch(function (error) {
        console.warn(
          'Cart badge refresh failed:',
          error
        );
      });
  }

  window.addEventListener('pageshow', function (event) {
    var navigation =
      window.performance &&
      performance.getEntriesByType
        ? performance.getEntriesByType('navigation')[0]
        : null;

    var returnedWithBackButton =
      event.persisted ||
      (navigation && navigation.type === 'back_forward');

    if (!returnedWithBackButton) {
      return;
    }

    refreshUpcart();
    refreshHeaderCart();
  });
})();
